import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { CELL_BY_SLUG } from "./dharshana/cells";
import Vision from "./Vision";

/**
 * `/dharshana` — legacy alias for `/vision` (July 8 rewrite).
 *
 * - `/dharshana`                → renders <Vision /> in place (no redirect,
 *                                 no URL change) so sitemap.xml still
 *                                 resolves and any old external link works.
 * - `/dharshana/{col-row}`      → redirect to `/vision#{row}-{col}`
 *                                 (scale-axis hash scheme). This preserves
 *                                 the 12 deep-linked cells that may be
 *                                 referenced externally.
 *
 * The old State 1/2/3 components are no longer rendered — they can be
 * removed in a future cleanup once we're sure no other route imports them.
 */
export default function Dharshana() {
  const { slug } = useParams();

  if (slug) {
    const cell = CELL_BY_SLUG[slug];
    if (cell) {
      // col-row (URL) → scale-axis (hash): scale = row, axis = col.
      return <Navigate to={`/vision#${cell.row}-${cell.col}`} replace />;
    }
    // Unknown slug — send to the vision top rather than 404.
    return <Navigate to="/vision" replace />;
  }

  // `/dharshana` (bare) — render the vision page in place. No redirect so
  // search engines that still index this URL land on real content, but the
  // canonical <link> inside <Vision /> points them at /vision.
  return <Vision />;
}
